module.exports = __webpack_public_path__ + "assets/img/SCHOOL BROCHURE.f7738609.png";